import { JOIN_ROUTES } from '../shared/registration.js';

/**
 * Public address for links given to players. In the local network (http://192.168.1.162)
 * the links still point to the public site.
 */
export const PUBLIC_ORIGIN = location.protocol === 'https:' ? location.origin : 'https://areena.eu';

export function joinUrl(kind: keyof typeof JOIN_ROUTES, param?: string): string {
  return `${PUBLIC_ORIGIN}/#/${JOIN_ROUTES[kind]}${param ? `/${encodeURIComponent(param)}` : ''}`;
}
